import HttpService from "../../SharedModule/utils/api";
import { Client } from "../types/clients-module-types";
const BASE_URL = "/clients";

function getClients(): Promise<Client[]> {
  return HttpService.req(`${BASE_URL}/clients?onlyActive=false`);
}

function getClientsDropdownsInfo(): Promise<any> {
  return HttpService.req(`${BASE_URL}/dropdowns/all`);
}

function getClientInfo(id: number): Promise<any> {
  return HttpService.req(`${BASE_URL}/clients/${id}`);
}

function getClientModuleHeaderInfo(id: number): Promise<any> {
  return HttpService.req(`${BASE_URL}/clients/${id}/ModuleHeaderInfo`);
}

function getClientBillingInfo(id: number): Promise<any> {
  return HttpService.req(`${BASE_URL}/${id}/billinginfo`);
}

function getClientContacts(id: number): Promise<any> {
  return HttpService.req(`${BASE_URL}/clients/${id}/contacts`);
}

function getClientContactProfile(contactId: number): Promise<any> {
  return HttpService.req(`${BASE_URL}/contacts/${contactId}/details`);
}

function getClientContactProfileByEmail(email: string): Promise<any> {
  return HttpService.req(`${BASE_URL}/contacts/${email}`);
}

function updateContactProfile(body: any, id: number): Promise<any> {
  return HttpService.req({
    method: "put",
    url: `${BASE_URL}/contacts/${id}`,
    data: { ...body },
  });
}

function addContact(body: any): Promise<any> {
  return HttpService.req({
    method: "post",
    url: `${BASE_URL}/contacts`,
    data: { ...body },
  });
}

function addInternalClient(body: any): Promise<any> {
  return HttpService.req({
    method: "post",
    url: `${BASE_URL}/clients/internal`,
    data: { ...body },
  });
}

function editInternalClient(body: any): Promise<any> {
  return HttpService.req({
    method: "post",
    url: `${BASE_URL}/clients/internal/update`,
    data: { ...body },
  });
}

function getClientWorkInfo(id: number): Promise<any> {
  return HttpService.req(`${BASE_URL}/businessintelligence/${id}/worktabinfo`);
}

function getClientRelationshipReviews(): Promise<any> {
  return HttpService.req(`${BASE_URL}/relationshipreview/relationshipreviews`);
}

function getClientKeyContacts(relationshipReviewId: any): Promise<any> {
  return HttpService.req(
    `${BASE_URL}/relationshipreview/${relationshipReviewId}/keycontacts`
  );
}

function addRelationshipReview(body: any): Promise<any> {
  return HttpService.req({
    method: "post",
    url: `${BASE_URL}/relationshipreview`,
    data: { ...body },
  });
}

function updateRelationshipReview(body: any): Promise<any> {
  return HttpService.req({
    method: "put",
    url: `${BASE_URL}/relationshipreview`,
    data: { ...body },
  });
}

function getKeyContactDetails(keyContactId: number): Promise<any> {
  return HttpService.req(`${BASE_URL}/keycontacts/${keyContactId}/details`);
}

function getKeyContactConfidenceHistory(keyContactId: number): Promise<any> {
  return HttpService.req(
    `${BASE_URL}/keycontacts/${keyContactId}/confidence-history`
  );
}

function addKeyContact(relationshipId: number, body: any): Promise<any> {
  return HttpService.req({
    method: "post",
    url: `${BASE_URL}/keycontacts/add?relationshipReviewId=${relationshipId}`,
    data: { ...body },
  });
}

function editKeyContact(
  relationshipId: number,
  keyContactId: number,
  body: any
): Promise<any> {
  return HttpService.req({
    method: "put",
    url: `${BASE_URL}/keycontacts/updatekeycontactdetails?relationshipReviewId=${relationshipId}&keyContactId=${keyContactId}`,
    data: { ...body },
  });
}

function deleteKeyContact(
  relationshipId: number,
  keyContactId: number
): Promise<any> {
  return HttpService.req({
    method: "patch",
    url: `${BASE_URL}/keycontacts/remove?relationshipReviewId=${relationshipId}&keyContactId=${keyContactId}`,
  });
}

function getSoc2ActiveClientsReport(): Promise<any> {
  return HttpService.req(`${BASE_URL}/reports/soc2-active-clients`);
}

function deactivateExternalClient(clientId: number): Promise<any> {
  return HttpService.req({
    method: "patch",
    url: `${BASE_URL}/clients/deactivate-external-client?clientId=${clientId}`,
  });
}

function deactivateInternalClient(clientId: number): Promise<any> {
  return HttpService.req({
    method: "patch",
    url: `${BASE_URL}/clients/deactivate-internal-client?clientId=${clientId}`,
  });
}

function reactivateExternalClient(clientId: number): Promise<any> {
  return HttpService.req({
    method: "patch",
    url: `${BASE_URL}/clients/reactivate-external-client?clientId=${clientId}`,
  });
}

function reactivateInternalClient(clientId: number): Promise<any> {
  return HttpService.req({
    method: "patch",
    url: `${BASE_URL}/clients/reactivate-internal-client?clientId=${clientId}`,
  });
}

export const ClientsService = {
  getClients,
  getClientsDropdownsInfo,
  getClientInfo,
  getClientModuleHeaderInfo,
  getClientBillingInfo,
  getClientContacts,
  getClientContactProfile,
  updateContactProfile,
  getClientContactProfileByEmail,
  addContact,
  addInternalClient,
  editInternalClient,
  getClientWorkInfo,
  getClientRelationshipReviews,
  getClientKeyContacts,
  addRelationshipReview,
  updateRelationshipReview,
  getKeyContactDetails,
  getKeyContactConfidenceHistory,
  addKeyContact,
  editKeyContact,
  deleteKeyContact,
  getSoc2ActiveClientsReport,
  deactivateExternalClient,
  deactivateInternalClient,
  reactivateExternalClient,
  reactivateInternalClient,
};
